<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="movements"
      :items-per-page="-1"
      class="elevation-1 white"
      height="inherit"
      hide-default-footer
    >
      <template
        v-slot:item="props"
        items-per-page="-1"
      >
        <tr>
          <td class="text-subtitle-1"> {{ props.item.created | moment("D MMMM YYYY HH:mm") }} </td>
          <td class="text-subtitle-1"> {{ props.item.creator.screenName }} </td>
          <td class="text-subtitle-1"> {{ props.item.note || '-' }} </td>
          <td><span :class="{ 'text-subtitle-1': true, 'font-weight-bold': true, 'red--text': props.item.amount < 0, 'green--text': props.item.amount >= 0 }">{{ props.item.amount | money }}</span></td>
        </tr>
      </template>
    </v-data-table>

    <v-speed-dial
      v-model="showDialButtons"
      bottom
      direction="top"
      fixed
      right
    >
      <template v-slot:activator>
        <v-btn
          v-model="showDialButtons"
          color="secondary darken-1"
          dark
          fab
        >
          <v-icon v-if="!showDialButtons">fal fa-exchange</v-icon>
          <v-icon v-else>fal fa-times</v-icon>
        </v-btn>
      </template>

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-3"
            color="red"
            dark
            fab
            v-on="on"
            @click="setCashOut();showAddDialog = true"
          >
            <v-icon>fal fa-minus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Cash-Out') }}</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-3"
            color="green"
            dark
            fab
            v-on="on"
            @click="setCashIn();showAddDialog = true"
          >
            <v-icon>fal fa-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Cash-In') }}</span>
      </v-tooltip>

      <v-tooltip
        v-show="cashRegister.openedReport"
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-3"
            color="black"
            dark
            fab
            v-on="on"
            @click="$router.push({ name: 'CashRegistersOpenClose' })"
          >
            <v-icon>fal fa-door-closed</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Close {0}', [$t('Cash Register')]) }}</span>
      </v-tooltip>
    </v-speed-dial>

    <v-dialog
      v-model="showAddDialog"
      eager
      max-width="550px"
    >
      <forms-cash-movements-save
        ref="form-add"
        :clear-input="showAddDialog"
        :focus-input="showAddDialog"
        :movement-type="movementType"
        @saved="itemAdded($event)"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import FormsCashMovementsSave from '@/components/forms/cash-movements/FormsCashMovementsSave'
import { CASH_MOVEMENT_ADD, CASH_MOVEMENT_REMOVE } from '@/utils/types/cash-movement'

export default {
  name: 'CashMovementsTable',

  components: {
    FormsCashMovementsSave
  },

  data () {
    return {
      headers: [
        {
          text: this.$t('Time'),
          value: 'created',
          sortable: false,
          class: 'text-h6'
        },
        {
          text: this.$t('Employee'),
          value: 'created_by',
          sortable: false,
          class: 'text-h6'
        },
        {
          text: this.$t('Note'),
          value: 'note',
          sortable: false,
          class: 'text-h6'
        },
        {
          text: this.$t('Amount'),
          value: 'amount',
          sortable: false,
          class: 'text-h6'
        }
      ],
      showAddDialog: false,
      showDialButtons: false,
      movementType: CASH_MOVEMENT_ADD
    }
  },

  computed: {
    ...mapGetters(['cashRegister']),
    movements () {
      const cashMovements = _.get(this.cashRegister, 'openedReport.cashMovements')
      return cashMovements
    }
  },

  methods: {
    itemAdded (item) {
      this.showAddDialog = false
      this.$emit('saved', item)
    },
    setCashIn () {
      this.movementType = CASH_MOVEMENT_ADD
    },
    setCashOut () {
      this.movementType = CASH_MOVEMENT_REMOVE
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cash-movements/CashMovementsTable.vue